/* eslint-disable no-unused-vars */
import React from 'react'
import Link from 'next/link'
import { Button } from 'antd'
import { useTranslation } from 'next-i18next'
import styles from './BuyMoreBalanceModal.module.scss'
import { CustomModal, CustomText } from 'src/components'

interface BuyMorBalanceModalProps {
  isModalVisible: boolean
  setIsModalVisible: (value: boolean) => void
}

const BuyMorBalanceModal: React.FC<BuyMorBalanceModalProps> = (props) => {
  const { t } = useTranslation()
  const labels: string[] = ['BuyMoreBalanceLi1', 'BuyMoreBalanceLi2', 'BuyMoreBalanceLi3']

  return <>
    <CustomModal
      width={300}
      footer={null}
      visible={props.isModalVisible}
      title={t('developers.BuyMoreCredits')}
      onCancel={() => props.setIsModalVisible(false)}
    >
      <CustomText label={t('developers.BuyMoreBalanceText1') } type='secondary' className={styles.font} />

      <ol className='ml-3 mt-3'>
        {labels.map((label, idx) => <li key={idx}>
          <CustomText label={t(`developers.${label}`) } type='secondary' className={styles.font} />
        </li>)}
      </ol>

      <Link href={process.env.MARKET_PLACE_URL} passHref legacyBehavior>
        <a target='_blank' rel='noopener noreferrer'>
          <Button
            block
            size='large'
            type='primary'
            className={styles.button}
          >{t('developers.GotoMarketplace')}
          </Button>
        </a>
      </Link>
    </CustomModal>
  </>
}
export default BuyMorBalanceModal
